// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type ChevronDown24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const ChevronDown24: FC<ChevronDown24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M19.2 10.343 12 16.24l-7.2-5.897 1.208-1.486L12 13.759l5.992-4.902 1.208 1.486Z" />
        </svg>
    );
};

export default ChevronDown24;
